/**
 * 侧边栏 - 分类导航
 */

import React from "react";
import { useStore } from "../store";
import { CATEGORY_NAMES } from "@passkeeper/shared";
import type { PasswordCategory } from "@passkeeper/shared";

interface Props {
  onAddClick: () => void;
}

const CATEGORIES: Array<{ key: PasswordCategory | "all"; icon: string }> = [
  { key: "all", icon: "📋" },
  { key: "social", icon: "👥" },
  { key: "email", icon: "📧" },
  { key: "shopping", icon: "🛒" },
  { key: "finance", icon: "💰" },
  { key: "work", icon: "💼" },
  { key: "entertainment", icon: "🎮" },
  { key: "developer", icon: "💻" },
  { key: "ai", icon: "🤖" },
  { key: "other", icon: "📁" },
];

export default function Sidebar({ onAddClick }: Props) {
  const {
    selectedCategory,
    setSelectedCategory,
    decryptedItems,
    items,
    masterPassword,
  } = useStore();

  const displayItems = masterPassword ? decryptedItems : items;

  const getCount = (cat: PasswordCategory | "all"): number => {
    if (cat === "all") return displayItems.length;
    return displayItems.filter((i) => i.category === cat).length;
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-section">
        <div className="sidebar-title">分类</div>
        {CATEGORIES.map(({ key, icon }) => (
          <div
            key={key}
            className={`category-item ${selectedCategory === key ? "active" : ""}`}
            onClick={() => setSelectedCategory(key)}
          >
            <span>{icon}</span>
            <span>{key === "all" ? "全部" : CATEGORY_NAMES[key as PasswordCategory]}</span>
            <span className="count">{getCount(key)}</span>
          </div>
        ))}
      </div>

      <div className="sidebar-section" style={{ marginTop: 24 }}>
        <button className="btn btn-primary" style={{ width: "100%" }} onClick={onAddClick}>
          + 添加密码
        </button>
      </div>
    </aside>
  );
}